import React from "react";
import { Helmet } from "react-helmet";


function Papers()
{
    var request = new XMLHttpRequest();
    request.open("GET", "data/papers.json", false);
    request.send(null);
    var json = JSON.parse(request.responseText);

    const elts = Object.values(json);
    console.log(elts);
    return (
        <div>
            <Helmet>
                <title>Papers | Lucas RODRIGUEZ</title>
            </Helmet>
            <h2>Research papers read/studied</h2>
            <p>
                These are some of the scientific papers I've read, studied & tried to self-reproduce by implementing key-results.
            </p>
            <div className="row">
                <div className="col-md-9">

                    <div class="list-group">
                        {elts.map((value) =>
                        {
                            var paper_title = value.title;
                            var paper_topics = value.topics;
                            var paper_authors = value.authors;
                            return <a class="list-group-item list-group-item-action">
                                <div class="d-flex w-100 justify-content-between">
                                    <b class="mb-1">{paper_title}</b>
                                </div>
                                <small class="text-muted"><u>Authors</u> : <i>{paper_authors}</i> &middot; <u>Topics</u> : <i>{paper_topics}</i></small>
                            </a>
                        })
                        }
                    </div>
                </div>
                <div className="col-md-3">
                </div>
            </div>
            <br />
            <p className="text-muted">
                The full-text document is available if no pay-wall has been set up (arXiv, HAL, ...)
            </p>
        </div>
    );
}

export default Papers;